import { State, closed, open } from './Types';
import { action, observable, makeObservable, computed } from 'mobx';

class AccordionToggleStore {
  @observable
  state: State = closed();

  constructor() {
    makeObservable(this);
  }

  @action
  close = () => {
    this.state = closed();
  };

  @action
  open = () => {
    this.state = open();
  };

  @computed
  get isOpen(): boolean {
    return this.state.kind === 'open';
  }
}

export default AccordionToggleStore;
